import { render, staticRenderFns } from "./produce_coordinate.vue?vue&type=template&id=57420230&scoped=true"
import script from "./produce_coordinate.vue?vue&type=script&lang=js"
export * from "./produce_coordinate.vue?vue&type=script&lang=js"
import style0 from "./produce_coordinate.vue?vue&type=style&index=0&id=57420230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57420230",
  null
  
)

export default component.exports